module.exports = __webpack_public_path__ + "static/media/payment-method-disabled.17ee23d4.png";